
export default function VisualShowcase() {
  return (
    <section className="bg-[#0E1A2B] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32">
          <div>
            <h3 className="font-serif text-3xl md:text-4xl text-[#F7F5F2] mb-6">
              Precision-engineered systems for legal operations
            </h3>
            <p className="text-lg text-[#8A8F98] leading-relaxed mb-8">
              Every system we deploy is designed with the same rigor law firms apply to their casework—structured, compliant, and built to perform under scrutiny.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-[#C8A14A]"></i>
                </div>
                <div>
                  <h4 className="text-[#F7F5F2] font-semibold mb-1">Confidentiality First</h4>
                  <p className="text-[#8A8F98] text-sm">All systems maintain attorney-client privilege standards</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-lock-line text-2xl text-[#C8A14A]"></i>
                </div>
                <div>
                  <h4 className="text-[#F7F5F2] font-semibold mb-1">Secure Infrastructure</h4>
                  <p className="text-[#8A8F98] text-sm">Enterprise-grade security protocols and data encryption</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-2xl text-[#C8A14A]"></i>
                </div>
                <div>
                  <h4 className="text-[#F7F5F2] font-semibold mb-1">Compliance Ready</h4>
                  <p className="text-[#8A8F98] text-sm">Built to meet legal industry regulatory requirements</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/3] bg-[#1C1C1E] border border-[#8A8F98]/20 overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/e57dab775207c088f199451bb6679636.jpg" 
                alt="Legal Technology Workspace" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="aspect-[4/3] bg-[#1C1C1E] border border-[#8A8F98]/20 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20artificial%20intelligence%20neural%20network%20patterns%20and%20data%20flow%20streams%20in%20dark%20navy%20blue%20and%20gold%20colors%2C%20representing%20legal%20automation%20systems%2C%20geometric%20precision%2C%20clean%20minimal%20design%2C%20professional%20technology%20aesthetic%2C%20structured%20grid%20patterns%2C%20sophisticated%20digital%20architecture%2C%20editorial%20style%20photography&width=800&height=600&seq=ai-systems-visual-002&orientation=landscape" 
                alt="AI Systems Architecture" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <h3 className="font-serif text-3xl md:text-4xl text-[#F7F5F2] mb-6">
              Intelligence that adapts to your firm's practice
            </h3>
            <p className="text-lg text-[#8A8F98] leading-relaxed mb-8">
              Our AI systems learn from your firm's workflows, terminology, and priorities—delivering automation that feels native to your practice, not generic.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-[#1C1C1E] p-6 border border-[#8A8F98]/20">
                <div className="text-[#C8A14A] text-3xl font-bold mb-2">24/7</div>
                <p className="text-[#8A8F98] text-sm">Client inquiry response capability</p>
              </div>
              <div className="bg-[#1C1C1E] p-6 border border-[#8A8F98]/20">
                <div className="text-[#C8A14A] text-3xl font-bold mb-2">85%</div>
                <p className="text-[#8A8F98] text-sm">Average reduction in intake processing time</p>
              </div>
              <div className="bg-[#1C1C1E] p-6 border border-[#8A8F98]/20">
                <div className="text-[#C8A14A] text-3xl font-bold mb-2">100%</div>
                <p className="text-[#8A8F98] text-sm">Compliance with legal confidentiality standards</p>
              </div>
              <div className="bg-[#1C1C1E] p-6 border border-[#8A8F98]/20">
                <div className="text-[#C8A14A] text-3xl font-bold mb-2">3x</div>
                <p className="text-[#8A8F98] text-sm">Improvement in lead qualification accuracy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
